// extracted by mini-css-extract-plugin
export default {"mixblogtop":"mixBlog_mixblogtop__coQTz"};